import { useState } from "react";
import PropTypes from "prop-types";
import Footer from "../components/Footer";
import LandingLayout from "../layouts/LandingLayout";
import Navbar from "../layouts/Navbar";
import TechonologyLayout from "../layouts/TechonologyLayout";
import ProjectsLayout from "../layouts/ProjectsLayout";

import { useLocation, useNavigate } from 'react-router-dom';

import './styles/basePage.css'
import Cursor from "../components/Cursor";
import Transitionner from "../components/Transitionner";

/**
 * Component representing the Home page of the application.
 * @returns {JSX.Element} The Home page component.
 */
export default function Home() {
    // State hooks to manage the component's state
    const [isAnimate, changeAnimationState] = useState(false);
    const [isAppearing, changeAppearing] = useState(false);
    const [isPageLocked, changeLockPage] = useState(true);

    /**
     * Handles a specific action.
     */

    /**
     * Triggers the delayed appearance of elements.
     */
    const delayedAppears = () => {
        changeAppearing(true);
    }

    setTimeout(delayedAppears, 500);

    /**
     * Unlocks the page after a delay.
     */
    const unlockPage = () => {
        changeLockPage(false);
    }

    setTimeout(unlockPage, 3100);

    
    const lockPage = () => {
        changeLockPage(true);
    }

    let location = useLocation()
    const navigate = useNavigate()
    const handleClick = (url) => {
        if(url !== location.pathname) {
            changeAnimationState(true);
            lockPage()
            setTimeout(() => {
                navigate(url)
            }, 1000)
        }
    }

    return (
        <div className={`homePage${isPageLocked ? " locked" : ""}`}>
            <Transitionner isAnimate={isAnimate} isAppearing={isAppearing} />
            <Cursor fadeOut={isAnimate} />

            <Navbar actionHandler={handleClick} fadeOut={isAnimate} />
            <LandingLayout fadeOut={isAnimate}/>
            <ProjectsLayout fadeOut={isAnimate} actionHandler={handleClick} />
            <TechonologyLayout fadeOut={isAnimate}/>
            <Footer fadeOut={isAnimate}/>
        </div>
    );
}

// PropTypes for the Home component
Home.propTypes = {
    // A property to trigger an action
    actionHandler: PropTypes.func,
};